export * from '@white-label-store/marketing-preferences-account';
